import { render, staticRenderFns } from "./FallingItem.vue?vue&type=template&id=617d5ddd&scoped=true&"
import script from "./FallingItem.vue?vue&type=script&lang=js&"
export * from "./FallingItem.vue?vue&type=script&lang=js&"
import style0 from "./FallingItem.vue?vue&type=style&index=0&id=617d5ddd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d5ddd",
  null
  
)

export default component.exports